import { render, staticRenderFns } from "./CreateWalletCheckout.vue?vue&type=template&id=23c8da6e&scoped=true"
import script from "./CreateWalletCheckout.vue?vue&type=script&lang=js"
export * from "./CreateWalletCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c8da6e",
  null
  
)

export default component.exports